import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import AppNavigatorSwitchWrapper from './AppNavigatorSwitch.web';

export default () => {
    return (
        <Router>
            <AppNavigatorSwitchWrapper />
        </Router>
    );
};
